// ─────────────────────────────────────────────────────────────────────────────
// DUEÑO DE CADA INDICADOR DEL DASHBOARD (28-ago-2026)
//
// El problema que resuelve: un admin veía Excepciones, F29 y Pagos DOS veces —en el
// Pulso del negocio y en el Pulso contable— y "OC por registrar" también dos —en el
// Pulso del negocio y en el del taller—. Un contable puro veía repetidos los tres
// primeros. Un tablero que repite números enseña a no leerlo.
//
// LA REGLA: cada indicador vive en el pulso del rol que TIENE QUE ACTUAR sobre él.
//
//   · Excepciones, F29 y Pagos son COLA DE TRABAJO del contable: hay que revisarlas,
//     declararlo y pagarlo. Van en el Pulso contable.
//   · "OC por registrar" es cola del taller: alguien tiene que ingresarla al ERP.
//   · El Pulso del negocio queda como lo que dice ser — resumen EJECUTIVO: resultado,
//     venta, cobranza y riesgo de concentración. No repite colas ajenas.
//
// El admin ve los tres pulsos, así que no pierde nada: ve cada número UNA vez, en el
// tablero al que pertenece.
//
// Esto es una tabla y no un comentario a propósito. Cada pulso la consulta antes de
// pedir el dato y antes de pintarlo, así que mover un indicador de un pulso a otro es
// cambiar una línea acá — y un test verifica que ningún indicador tenga dos dueños,
// que es exactamente el error que se está corrigiendo.
// ─────────────────────────────────────────────────────────────────────────────

export const PULSOS = ["negocio", "contable", "taller"];

/** Indicador → pulso que lo muestra. Uno y sólo uno. */
export const DUENO = {
  // Resumen ejecutivo.
  utilidad: "negocio",
  ventas: "negocio",
  porCobrar: "negocio",
  topPiezas: "negocio",
  concentracion: "negocio",

  // Cola del contable.
  excepciones: "contable",
  f29: "contable",
  pagos: "contable",
  liquidaciones: "contable",
  comprasSinVincular: "contable",

  // Cola del taller.
  ocPorRegistrar: "taller",
};

/**
 * ¿Este pulso muestra este indicador?
 *
 * Un indicador que no está en la tabla devuelve `false` en TODOS los pulsos: es
 * deliberado. Si alguien agrega una tarjeta y se olvida de declarar su dueño, no
 * aparece en ninguna parte y se nota enseguida — que es mucho mejor que aparecer en
 * dos, que es el problema que trajo hasta acá.
 */
export const esDe = (pulso, indicador) => DUENO[indicador] === pulso;
